function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.301998,
  d: "M58.782 80.792C65.5861 79.6994 68.34 78.8774 74.9831 72.4924C81.6261 66.1074 88.3622 75.4227 98.3524 71.6827C108.343 67.9427 109.256 63.4146 124.536 77.2852C131.58 83.1803 137.182 80.8465 140.635 83.1803C142.936 84.7361 145.155 88.5714 147.29 94.6862H141.724H58.782C51.735 92.2401 48.2114 90.2087 48.2114 88.5918C48.2114 86.1664 51.978 81.8847 58.782 80.792Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M202.62 143.61C202.62 147.5 178.82 146.547 171.992 147.51C160.541 149.126 185.208 156.414 143.628 157.229C108.845 157.91 71.3893 154.73 72.3349 146.525C73.2805 138.319 100.945 133.847 135.98 133.847C171.014 133.847 202.62 135.44 202.62 143.61Z",
  fill: "url(#paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.301998
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.301998,
  d: "M48.3154 113.579V159.025L64.7304 165.058V117.883L48.3154 113.579Z",
  fill: "url(#paint2_linear)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.301998,
  d: "M64.7046 117.817L79.9263 112.223V159.238L64.7046 164.99V117.817Z",
  fill: "url(#paint3_linear)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.301998,
  d: "M48.2114 113.534L63.7153 107.838L79.9231 112.259L64.6965 117.855L48.2114 113.534Z",
  fill: "url(#paint4_linear)"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M95.8112 68.3538C96.7219 68.3538 97.4602 67.6166 97.4602 66.7072C97.4602 65.7978 96.7219 65.0605 95.8112 65.0605C94.9004 65.0605 94.1621 65.7978 94.1621 66.7072C94.1621 67.6166 94.9004 68.3538 95.8112 68.3538Z",
  fill: "url(#paint5_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M101.583 68.3538C102.494 68.3538 103.232 67.6166 103.232 66.7072C103.232 65.7978 102.494 65.0605 101.583 65.0605C100.672 65.0605 99.9341 65.7978 99.9341 66.7072C99.9341 67.6166 100.672 68.3538 101.583 68.3538Z",
  fill: "url(#paint6_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M107.355 68.3538C108.265 68.3538 109.004 67.6166 109.004 66.7072C109.004 65.7978 108.265 65.0605 107.355 65.0605C106.444 65.0605 105.706 65.7978 105.706 66.7072C105.706 67.6166 106.444 68.3538 107.355 68.3538Z",
  fill: "url(#paint7_linear)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.301998,
  d: "M181.245 77H109.755C108.786 77 108 77.6693 108 78.4949V133.505C108 134.331 108.786 135 109.755 135H181.245C182.214 135 183 134.331 183 133.505V78.4949C183 77.6693 182.214 77 181.245 77Z",
  fill: "url(#paint8_linear)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M197.28 115.06C197.28 112.192 194.955 109.868 192.088 109.868C189.221 109.868 186.897 112.192 186.897 115.06V123.406C186.897 126.273 189.221 128.597 192.088 128.597C194.955 128.597 197.28 126.273 197.28 123.406V115.06Z",
  stroke: "#E2E2EA",
  strokeWidth: 7.7533
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M206.298 118.191H177.878C177.493 118.191 177.181 118.504 177.181 118.889V144.568C177.181 144.953 177.493 145.265 177.878 145.265H206.298C206.683 145.265 206.996 144.953 206.996 144.568V118.889C206.996 118.504 206.683 118.191 206.298 118.191Z",
  fill: "url(#paint9_linear)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M161.15 108.3C166.755 108.3 171.3 103.755 171.3 98.1498C171.3 92.5442 166.755 88 161.15 88C155.544 88 151 92.5442 151 98.1498C151 103.755 155.544 108.3 161.15 108.3Z",
  fill: "url(#paint10_linear)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M118.822 113.835H97.8621C97.4644 113.835 97.1421 114.157 97.1421 114.555V116.815C97.1421 117.212 97.4644 117.535 97.8621 117.535H118.822C119.219 117.535 119.542 117.212 119.542 116.815V114.555C119.542 114.157 119.219 113.835 118.822 113.835Z",
  fill: "#EBEBF2"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M109.622 121.421H99.8621C99.4644 121.421 99.1421 121.744 99.1421 122.141V124.401C99.1421 124.799 99.4644 125.121 99.8621 125.121H109.622C110.019 125.121 110.342 124.799 110.342 124.401V122.141C110.342 121.744 110.019 121.421 109.622 121.421Z",
  fill: "#EBEBF2"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M134.221 113.835H123.761C123.363 113.835 123.041 114.157 123.041 114.555V116.815C123.041 117.212 123.363 117.535 123.761 117.535H134.221C134.618 117.535 134.941 117.212 134.941 116.815V114.555C134.941 114.157 134.618 113.835 134.221 113.835Z",
  fill: "#EBEBF2"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M170.62 113.835H137.761C137.363 113.835 137.041 114.157 137.041 114.555V116.815C137.041 117.212 137.363 117.535 137.761 117.535H170.62C171.018 117.535 171.34 117.212 171.34 116.815V114.555C171.34 114.157 171.018 113.835 170.62 113.835Z",
  fill: "#EBEBF2"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M167.161 121.421H125.761C125.363 121.421 125.041 121.744 125.041 122.141V124.401C125.041 124.799 125.363 125.121 125.761 125.121H167.161C167.559 125.121 167.881 124.799 167.881 124.401V122.141C167.881 121.744 167.559 121.421 167.161 121.421Z",
  fill: "#EBEBF2"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M192.088 125.828C194.195 125.828 195.902 127.537 195.902 129.646C195.902 131.13 195.057 132.416 193.822 133.048L193.822 136.932C193.822 137.317 193.509 137.629 193.124 137.629H191.053C190.667 137.629 190.355 137.317 190.355 136.932L190.355 133.048C189.12 132.416 188.275 131.13 188.275 129.646C188.275 127.537 189.982 125.828 192.088 125.828Z",
  fill: "url(#paint11_linear)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M76.5867 141.593C76.4307 143.11 76.4797 144.087 76.7336 144.523C77.1144 145.177 76.6346 145.892 75.9101 145.479C75.1856 145.065 74.5853 142.836 74.2947 142.336C74.0042 141.837 73.0448 140.664 75.0072 140.273C76.3154 140.013 76.9664 140.064 76.96 140.426L77.1567 141.293L76.5867 141.593Z",
  fill: "#3E3E6E"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M109.1 143.115C110.606 143.55 111.62 143.703 112.142 143.575C112.925 143.382 113.513 143.932 112.874 144.465C112.235 144.998 109.775 145.063 109.178 145.21C108.58 145.358 107.094 145.938 107.279 144.193C107.403 143.03 107.649 142.487 108.018 142.565L108.963 142.57L109.1 143.115Z",
  fill: "#3E3E6E"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M98.6765 89.2168C99.5445 90.4794 99.3981 93.4831 98.5102 94.0233C98.1322 94.2532 97.3307 94.4565 96.5645 94.2904C96.6407 94.6895 96.7121 95.0299 96.7786 95.3117C96.9765 96.1506 97.3124 96.7192 97.7864 97.0176L92.9611 96.7561C93.7241 96.2714 94.2103 95.7167 94.4199 95.092C94.5551 94.6892 94.6515 94.0298 94.7092 93.1139C93.9262 92.2753 93.3927 91.1447 93.4422 90.0999C93.5636 87.5355 97.8085 87.9542 98.6765 89.2168Z",
  fill: "url(#paint12_linear)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M94.7563 93.9516C94.1844 92.2507 92.6275 90.2432 92.7506 89.4733C92.8327 88.9601 93.1383 88.6345 93.6673 88.4964C93.8621 87.4781 94.7261 87.0251 96.2591 87.1375C96.6008 87.1625 97.0924 87.4802 97.437 87.4496C98.0539 87.3949 98.2535 87.3375 98.6798 87.3648C99.2403 87.4007 99.5811 87.6303 99.7992 88.0174C100.067 88.4924 99.8399 89.1824 99.2007 89.6418C98.6254 90.0551 97.9946 89.8535 97.5698 90.0099C97.2852 90.1147 96.8815 90.7351 96.3586 91.8711L96.2491 91.5235C95.978 90.8315 95.6524 90.5702 95.2724 90.7395C94.8924 90.9088 94.8186 91.213 95.0511 91.6521C95.3194 92.5034 95.4386 93.053 95.4086 93.3007C95.3785 93.5485 95.1611 93.7655 94.7563 93.9516Z",
  fill: "#353564"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M92.0869 101.462C88.2421 104.031 85.9102 107.479 85.0912 111.806C85.0751 112.845 86.5042 113.981 85.3055 114.402C84.1069 114.824 83.8673 113.684 83.8388 112.238C83.8104 110.791 83.1158 106.05 84.6877 103.664C85.7356 102.073 87.4488 100.308 89.8272 98.37L92.0869 101.462Z",
  fill: "url(#paint13_linear)"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M98.4199 101.289C98.9739 102.726 100.304 104.436 102.411 106.42C104.378 107.657 107.04 106.442 111.414 105.824C114.032 105.882 115.068 104.149 114.307 103.731C113.546 103.313 111.962 103.779 111.611 104.425C111.377 104.855 108.838 104.596 103.992 103.647L102.09 100.346L98.4199 101.289Z",
  fill: "url(#paint14_linear)"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M99.5626 105.616C102.549 103.739 103.99 102.642 103.885 102.324C103.727 101.846 101.968 99.0849 100.996 98.2568C100.024 97.4287 98.1479 95.555 97.4489 98.2568C96.9828 100.058 97.6874 102.511 99.5626 105.616Z",
  fill: "#5B5BEA"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M86.4293 100.585C88.6249 102.332 89.8511 103.113 90.108 102.927C90.4932 102.648 94.9202 100.31 95.3864 99.2084C95.8526 98.1065 95.8526 95.8285 93.9302 95.5163C92.6486 95.3081 90.1483 96.9977 86.4293 100.585Z",
  fill: "#5B5BEA"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M107.136 142.899L109.305 142.65C108.841 138.992 107.824 134.629 106.253 129.559C104.682 124.49 102.797 119.916 100.599 115.838H89.9199C92.1887 119.368 94.0779 122.107 95.5875 124.055C97.6699 126.743 100.227 130.228 101.675 132.658C104.699 137.729 106.52 141.143 107.136 142.899Z",
  fill: "url(#paint15_linear)"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M76.0566 139.785L76.7732 141.775C85.0851 140.945 89.802 136.063 91.6166 134.324C93.4313 132.585 94.8873 126.45 97.209 115.188L88.2925 114.212C86.8215 123.434 87.1554 131.256 86.9816 131.644C86.8078 132.031 82.4876 137.462 76.0566 139.785Z",
  fill: "url(#paint16_linear)"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M100.787 99.2611C100.998 98.451 101.023 101.068 100.863 107.113C100.79 109.87 102.471 115.109 100.849 116.287C98.6339 117.896 86.9705 117.781 86.9705 116.732C86.9705 113.163 87.9751 107.786 89.9201 103.304C91.4774 99.7149 91.347 96.0704 93.7588 95.534C94.359 95.4005 95.0673 96.072 96.0557 96.2713C96.8873 96.4389 97.3818 96.0598 98.008 96.2713C99.5486 96.7914 100.475 97.788 100.787 99.2611Z",
  fill: "#5B5BEA"
});

var _ref29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 97.7508,
  y1: 67.8738,
  x2: 97.7508,
  y2: 94.3076,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCDCE4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DEDEE6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 95.0656,
  y1: 145.492,
  x2: 183.743,
  y2: 154.319,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EDEDF2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F9F9FC",
  stopOpacity: 0.88
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 51.3769,
  y1: 119.276,
  x2: 51.3769,
  y2: 163.614,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEEEEE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DEDEE6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 72.3155,
  y1: 112.223,
  x2: 72.3155,
  y2: 164.99,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCDCE4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DEDEE6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 64.0672,
  y1: 107.838,
  x2: 64.0672,
  y2: 117.855,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCDCE4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DEDEE6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 95.8112,
  y1: 65.0605,
  x2: 95.8112,
  y2: 68.3538,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FCFCFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAFAFC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 101.583,
  y1: 65.0605,
  x2: 101.583,
  y2: 68.3538,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FCFCFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAFAFC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 107.355,
  y1: 65.0605,
  x2: 107.355,
  y2: 68.3538,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FCFCFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAFAFC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 145.5,
  y1: 77,
  x2: 145.5,
  y2: 134.181,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCDCE4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DEDEE6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 197.46,
  y1: 122.367,
  x2: 197.46,
  y2: 145.265,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4F4F9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E2E2E9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: 166,
  y1: 106.5,
  x2: 157.5,
  y2: 88,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4F4F9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E2E2E9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: 192.088,
  y1: 135.589,
  x2: 189.808,
  y2: 128.378,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5B942"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD278"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear",
  x1: 97.3338,
  y1: 90.7942,
  x2: 95.2599,
  y2: 94.5571,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD2C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFB8A3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear",
  x1: 80.3605,
  y1: 115.895,
  x2: 85.9729,
  y2: 100.504,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD2C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFB8A3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear",
  x1: 94.4549,
  y1: 101.832,
  x2: 109.797,
  y2: 108.964,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD2C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFB8A3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear",
  x1: 96.9312,
  y1: 141.609,
  x2: 102.048,
  y2: 117.401,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7878C3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5C5CBB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear",
  x1: 83.2748,
  y1: 140.46,
  x2: 88.8621,
  y2: 115.785,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7878C3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5C5CBB"
})));

var SvgAuthTeam = function SvgAuthTeam(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 216,
    viewBox: "0 0 288 216",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAuthTeam, _extends({
    svgRef: ref
  }, props));
});
export default "https://sf16-website.neutral.ttwstatic.com/obj/tiktok_web_static/bytecom/api_gateway_web_i18n/static/media/authTeam.f701be74.svg";
export { ForwardRef as ReactComponent };